module.exports = __webpack_public_path__ + "static/media/Decisions_Step6_Image1.9b9f55ca.jpg";